export default {
  'CustomerWithoutMovement.label.OSSituation': 'Situação da O.S.',
  'CustomerWithoutMovement.label.type': 'Tipo',
  'CustomerWithoutMovement.label.moreOptions': 'Mais Opções',

  'CustomerWithoutMovement.option.open': 'Abertos',
  'CustomerWithoutMovement.option.authorized': 'Autorizados',
  'CustomerWithoutMovement.option.closed': 'Fechados',
  'CustomerWithoutMovement.option.budget': 'Orçamento',
  'CustomerWithoutMovement.option.warranty': 'Garantia',
  'CustomerWithoutMovement.option.return': 'Retorno',
  'CustomerWithoutMovement.option.courtesy': 'Cortesia',
  'CustomerWithoutMovement.option.insideCourtesy': 'Interna (Cortesia)',
  'CustomerWithoutMovement.option.revision': 'Revisão',

  'CustomerWithoutMovement.checkbox.inactiveCustomers':
    'Mostrar clientes inativos?',
};
